type ErrorWithMessage = {
  message: string;
};

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as Record<string, unknown>).message === "string"
  );
}

function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
  if (isErrorWithMessage(maybeError)) return maybeError;
  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    return new Error(String(maybeError));
  }
}

export function getErrorMessage(error: unknown) {
  const errorMsg = toErrorWithMessage(error).message;
  if (errorMsg.includes("Smart contract panicked")) {
    return errorMsg.split("'")[1];
  } else {
    return `An Error Has Occurred. Please Try Again, And If The Problem Persists, Contact The System Administrator.`;
  }
}
